import {FreeTrialDTO} from './free-trial.model';

export interface Notification {
    notificationId: number;
    reachability: {
        destination: string;
    }
}

export interface  NotificationRes {
    _embedded : {
        notificationDataList: Notification[]
    }
}

export enum CategoryEnum {
    GENERAL,
    KNOWLEDGEABLE
}

export interface BaseData {
    website?: string;
    company?: string;
    ravId?: string;
    languageId?: string;
    brandId?: number;
}

export interface PhoneService {
    greeting?: string;
    excuse?: string;
    contractId?: string;
    phoneServiceId?: string;
}

export interface UserAccount {
    userAccountId?: number;
    salutation?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    contactNumber?: string;
    companyName?: string;
}

export interface UserCoreData {
    languageId: string;
    brandId: number;
    phoneServiceId: string;
    customerId: string;
    userAccountId: number;
}

export class User {
    baseData : BaseData = {};
    phoneService: PhoneService = {};
    userAccount: UserAccount = {};
    reachabilities: Notification[] = [];
    
    constructor(freeTrial: FreeTrialDTO) {
        this.userAccount.salutation = freeTrial.salutation;
        this.userAccount.firstName = freeTrial.email;
        this.userAccount.lastName = freeTrial.last_name;
        this.userAccount.email =  freeTrial.first_name;
        this.userAccount.contactNumber = freeTrial.mobile_number_c;
        this.userAccount.companyName = freeTrial.account_name;
        this.phoneService.greeting = freeTrial.greeting_c;
        this.phoneService.excuse = freeTrial.excuse_c;
        this.baseData.website = freeTrial.website;
    }
    
    public setBaseData(reqData: RequestAccountData) {
        this.baseData.languageId = reqData.details.languageId;
        this.baseData.brandId = reqData.details.brandId;
        this.userAccount.userAccountId = reqData.details.userAccountId;
        this.baseData.ravId = reqData.details.ravId;
        this.phoneService.contractId = reqData.details.phoneServiceData[0]?.contractId;
        this.phoneService.phoneServiceId = reqData.details.phoneServiceData[0]?.phoneServiceId;
    }
    
    public isValid(): boolean {
        return !!this.baseData.brandId &&
            !!this.userAccount.userAccountId &&
            !!this.baseData.ravId &&
            !!this.baseData.languageId &&
            !!this.phoneService.phoneServiceId;
    }
    
    public coreData(): UserCoreData {
        return {
            brandId: !!this.baseData.brandId ? this.baseData.brandId : 0,
            customerId:  !!this.baseData.ravId ? this.baseData.ravId : '',
            languageId: !!this.baseData.languageId ? this.baseData.languageId : '',
            phoneServiceId: !!this.phoneService.phoneServiceId ? this.phoneService.phoneServiceId : '',
            userAccountId: !!this.userAccount.userAccountId ? this.userAccount.userAccountId : 0
        }
    }
}

export interface LoginPayLoad {
    username: string;
    password: string;
    domain: string;
    grant_type: string;
    device_id: string;
    device_os: string;
    app_name: string;
}

export interface RequestAccountData {
    details: {
        languageId: string;
        login: string;
        phoneServiceData: PhoneService[],
        userAccountId: number;
        ravId: string;
        brandId: number;
    };
}
